import { ImageOff } from "lucide-react";

/* Renders a real image with brutalist framing, or a labelled placeholder
   while the asset is still being uploaded. */
export function CaseImage({ img, testid }) {
  if (img.placeholder) {
    return (
      <div
        className="border border-dashed border-[#0A0A0A] bg-[#EDE9FE] flex flex-col items-center justify-center text-center px-6 py-16 min-h-[280px]"
        data-testid={`${testid}-placeholder`}
      >
        <ImageOff size={22} strokeWidth={1.5} className="text-[#595959] mb-4" />
        <span className="label-mono text-[#595959] mb-2">
          {img.label || "Awaiting asset"}
        </span>
        <span className="font-mono-ibm text-xs text-[#8A8A8A] break-all">
          {img.file}
        </span>
      </div>
    );
  }
  return (
    <img
      src={img.src}
      alt={img.alt}
      loading="lazy"
      className="w-full h-auto border border-[#0A0A0A] bg-white"
      data-testid={testid}
    />
  );
}

export function PhoneFrame({ src, alt, testid, eager = false }) {
  return (
    <div
      data-testid={testid}
      className="relative bg-[#0A0A0A] rounded-[2.1rem] p-[6px] shadow-[0_16px_50px_-16px_rgba(91,33,182,0.5)]"
    >
      <div className="overflow-hidden rounded-[1.7rem] bg-white">
        <img
          src={src}
          alt={alt}
          loading={eager ? "eager" : "lazy"}
          className="w-full h-auto block"
        />
      </div>
    </div>
  );
}

export function Lines({ lines, accentClass = "text-[#4C1D95]" }) {
  return (
    <>
      {lines.map((l, i) => (
        <span key={`${l.t}-${l.s || ""}`}>
          {l.a ? <span className={accentClass}>{l.t}</span> : l.t}
          {l.s || ""}
          {i < lines.length - 1 && <br />}
        </span>
      ))}
    </>
  );
}

export function SectionHead({ index, kicker, children }) {
  return (
    <div className="mb-8 md:mb-10">
      <p className="label-mono text-[#595959] mb-4">
        / {index} — {kicker}
      </p>
      <h2 className="font-display text-4xl md:text-5xl tracking-tighter">
        {children}
      </h2>
    </div>
  );
}
